/**
 * Created by Ning Jiang on 10/24/2018.
 */

import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {EdisonGameConfig} from "../../EdisonGameConfig";

export class EdisonReelSymbolStateCreator extends ReelSymbolStateCreator {

    constructor() {
        super();
    }

    protected noWinStateCreator(symbol:StateReelSymbol, stateKey:string, stateConfig:ISymbolStateConfig):TimelineSprite | null {
        const stateAnimation:TimelineSprite | null = this.getBasicStateAnimation(symbol, stateKey, stateConfig);
        if(stateAnimation) {
            let symW:number = EdisonGameConfig.instance.SYMBOL_WIDTH;
            let symH:number = 151;
            let grp:PIXI.Graphics = new PIXI.Graphics();
            grp.beginFill(0x0e0e0f, .75);
            grp.drawRect(-symW / 2, -symH / 2 - 2, symW, symH);
            stateAnimation.addChild(grp);

            if(symbol.symName === "S")
                stateAnimation.tint = 0x555555;
        }
        return stateAnimation;
    }

    protected noWinFSStateCreator(symbol:StateReelSymbol, stateKey:string, stateConfig:ISymbolStateConfig):TimelineSprite | null {
        const stateAnimation:TimelineSprite | null = this.getBasicStateAnimation(symbol, stateKey, stateConfig);
        if(stateAnimation) {
            let symW:number = EdisonGameConfig.instance.SYMBOL_WIDTH;
            let symH:number = 151;
            let grp:PIXI.Graphics = new PIXI.Graphics();
            grp.beginFill(0x0e0e0f, .50);
            grp.drawRect(-symW / 2, -symH / 2 - 2, symW, symH);
            stateAnimation.addChild(grp);
        }
        return stateAnimation;
    }

    protected getBasicStateAnimation(symbol:StateReelSymbol, stateKey:string, stateConfig:ISymbolStateConfig):TimelineSprite | null {
        let sprite:TimelineSprite | null = super.getBasicStateAnimation(symbol, stateKey, stateConfig);

        return sprite;
    }
}